// extracted by mini-css-extract-plugin
module.exports = {"stickyContainer":"purify_stickyBar__stickyContainer--17pGq","requestACallButton":"purify_stickyBar__requestACallButton--354fV"};